module.exports = __webpack_public_path__ + "img/VN-nm.9bb10978.png";